<template>
  <div class="contact-form flex-grow-1 d-flex flex-column overflow-y-hidden">
    <a-form id="contact-form" class="flex-grow-1 d-flex flex-column overflow-y-hidden" :form="contactForm" @submit="onSubmit">
      <div class="a-header">
        <span class="a-header--title slide-down-enter-active">{{ contact.id ? 'Edit' : 'Add' }} Contact</span>
      </div>
      <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
        <Spinner />
      </div>
      <div class="a-body flex-grow-1">
        <transition-group name="slide-up">
          <template v-if="!isLoading">
            <a-row :key="'info'" :gutter="20">
              <a-col :span="12">
                <a-form-item label="Name" class="name">
                  <a-input
                    v-decorator="[
                      'name',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please input Name!'
                          }
                        ]
                      }
                    ]"
                    placeholder="Name"
                  >
                  </a-input>
                </a-form-item>
                <a-form-item label="Contact Group">
                  <a-select
                    v-decorator="[
                      'contact_group_id',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select Contact Group!'
                          }
                        ]
                      }
                    ]"
                    showSearch
                    size="large"
                  >
                    <a-select-option v-for="group in contactGroups" :key="group.id">
                      {{ group.description }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="Description">
                  <a-textarea v-decorator="['description']" class="row-6" placeholder="Description" :rows="6" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :key="'email'" :gutter="20">
              <a-col :span="12">
                <div class="email-config">
                  <span class="email-config__title">Email Alert Configurations</span>
                  <a-row :gutter="20">
                    <a-col :span="24">
                      <a-row :gutter="20">
                        <a-col :span="12">
                          <a-form-item label="Email">
                            <a-input
                              v-decorator="[
                                'email',
                                {
                                  rules: [
                                    {
                                      required: true,
                                      whitespace: true,
                                      message: 'Please input your Email!'
                                    },
                                    {
                                      message: 'Email invalid!',
                                      type: 'email'
                                    }
                                  ]
                                }
                              ]"
                              postfix
                              placeholder="Email"
                            >
                            </a-input>
                          </a-form-item>
                        </a-col>
                        <a-col :span="12">
                          <a-form-item>
                            <template slot="label">
                              Email Subject Prefix
                              <a-tooltip placement="top">
                                <template slot="title">
                                  <span>
                                    The text specified here will be added to the front of the subject in the email alerts
                                  </span>
                                </template>
                                <a-icon type="info-circle" theme="filled" />
                              </a-tooltip>
                            </template>
                            <a-input v-decorator="['email_subject_prefix']" placeholder="Email Subject Prefix"> </a-input>
                          </a-form-item>
                        </a-col>
                      </a-row>
                      <a-row :gutter="20">
                        <a-col :span="12">
                          <a-row :gutter="20">
                            <a-col :span="12">
                              <a-form-item label="Notification Period">
                                <a-select v-decorator="['notif_from']">
                                  <a-select-option v-for="timeOption in timeOptions" :value="timeOption.value" :key="timeOption.value">{{ timeOption.label }}</a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-item class="mt-40">
                                <a-select v-decorator="['notif_to']">
                                  <a-select-option v-for="timeOption in timeOptions" :value="timeOption.value" :key="timeOption.value">{{ timeOption.label }}</a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                          </a-row>
                        </a-col>
                        <a-col :span="12">
                          <a-form-item label="Alert on">
                            <a-checkbox-group
                              v-decorator="[
                                'notif_day',
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Please select Notification Date!'
                                    }
                                  ]
                                }
                              ]"
                              :options="dayList"
                            />
                          </a-form-item>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                  <div>
                    <a-row>
                      <a-col :span="12">
                        <a-form-item class="mb-0">
                          <a-checkbox v-decorator="['batch_email', { valuePropName: 'checked' }]">
                            Batch Email Alerts
                            <a-tooltip placement="top">
                              <template slot="title">
                                <span>
                                  Group multiple emails alerts every 5 minutes and consolidate as a single email
                                </span>
                              </template>
                              <a-icon class="explain" type="info-circle" theme="filled" />
                            </a-tooltip>
                          </a-checkbox>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </a-col>
              <a-col :span="12" v-if="isShowSMSConfig">
                <div class="email-config">
                  <span class="email-config__title">SMS Alert Configurations</span>
                  <a-row :gutter="20">
                    <a-col :span="24">
                      <a-row :gutter="20">
                        <a-col :span="24">
                          <a-form-item label="Phone">
                            <a-input
                              v-decorator="[
                                'sms',
                                {
                                  rules: [
                                    {
                                      min: 5,
                                      max: 20,
                                      message: 'The sms must be between 5 and 20 digits.'
                                    },
                                    {
                                      pattern: '^[0-9]+$',
                                      message: 'Phone Invalid'
                                    }
                                  ]
                                }
                              ]"
                              class="full-w"
                            >
                              <a-select slot="addonBefore" defaultValue="65" style="width: 70px;">
                                <a-select-option value="65">
                                  +65
                                </a-select-option>
                              </a-select>
                            </a-input>
                          </a-form-item>
                        </a-col>
                      </a-row>
                      <a-row :gutter="20">
                        <a-col :span="12">
                          <a-row :gutter="20">
                            <a-col :span="12">
                              <a-form-item label="Notification Period">
                                <a-select v-decorator="['notif_from_sms']">
                                  <a-select-option v-for="timeOption in timeOptions" :value="timeOption.value" :key="timeOption.value">{{ timeOption.label }}</a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                            <a-col :span="12">
                              <a-form-item class="mt-40">
                                <a-select v-decorator="['notif_to_sms']">
                                  <a-select-option v-for="timeOption in timeOptions" :value="timeOption.value" :key="timeOption.value">{{ timeOption.label }}</a-select-option>
                                </a-select>
                              </a-form-item>
                            </a-col>
                          </a-row>
                        </a-col>
                        <a-col :span="12">
                          <a-form-item label="Alert on">
                            <a-checkbox-group
                              v-decorator="[
                                'notif_day_sms',
                                {
                                  rules: [
                                    {
                                      required: true,
                                      message: 'Please select SMS Notification Date!'
                                    }
                                  ]
                                }
                              ]"
                              :options="dayList"
                            />
                          </a-form-item>
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </div>
              </a-col>
            </a-row>
            <div :key="'option'" class="mt-4">
              <a-form-item class="mb-0">
                <a-checkbox v-decorator="['enable_email_baseline', { valuePropName: 'checked' }]">
                  Allow Rebaseline via Email
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>
                        Allows contact to rebaseline using a HTTPS link sent in email alert
                      </span>
                    </template>
                    <a-icon class="explain" type="info-circle" theme="filled" />
                  </a-tooltip>
                </a-checkbox>
              </a-form-item>
              <small class="">
                *Enable this only if your organization's security policy allows this.
              </small>
            </div>
          </template>
        </transition-group>
      </div>
      <div class="a-footer">
        <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
          Cancel
        </a-button>
        <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
          Save
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
  const dayList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  import moment from 'moment';
  import ContactGroupService from '@modules/ContactGroup/services/contact-group.service';

  export default {
    name: 'ContactFrom',
    props: {
      contact: {
        id: Number,
        contact_group_id: Number,
        name: String,
        email: String,
        sms: String,
        enable_email_baseline: Boolean,
        description: String,
        notif_from: String,
        notif_to: String,
        notif_day: Array,
        notif_from_sms: String,
        notif_to_sms: String,
        notif_day_sms: Array,
        batch_email: Boolean,
        email_subject_prefix: String
      },
    },
    data() {
      return {
        dayList,
        contactGroups: [],
        timeOptions: [],
        isLoading: true
      };
    },
    computed: {
      isShowSMSConfig() {
        //return Boolean(this.$store.state.user.data.rbac && this.$store.state.user.data.rbac.length > 0 && this.$store.state.user.data.rbac[0]);
        return this.$store.state.user.data.feature_access && this.$store.state.user.data.feature_access['sms'];
      }
    },
    watch: {
      contact: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setContactForm();
        }
      }
    },
    beforeCreate() {
      this.contactForm = this.$form.createForm(this, { name: 'contact-form' });
      this.contactForm.getFieldDecorator('notif_from', {});
      this.contactForm.getFieldDecorator('notif_to', {});
      this.contactForm.getFieldDecorator('batch_email', {});
      this.contactForm.getFieldDecorator('enable_email_baseline', {});
      this.contactForm.getFieldDecorator('contact_group_id', {});
      this.contactForm.getFieldDecorator('name', {});
      this.contactForm.getFieldDecorator('email', {});
      this.contactForm.getFieldDecorator('description', {});
      this.contactForm.getFieldDecorator('notif_day', {});
      this.contactForm.getFieldDecorator('email_subject_prefix', {});
      this.contactForm.getFieldDecorator('notif_from_sms', {});
      this.contactForm.getFieldDecorator('notif_to_sms', {});
      this.contactForm.getFieldDecorator('notif_day_sms', {});
      this.contactForm.getFieldDecorator('sms', {});
    },
    mounted() {
      this.getContactGroupList();

      this.timeOptions = [];
      for (let hour = 0; hour <= 24; hour++) { // <= 24 is not an error, we want to show 24:00
        let hourPad = '' + hour;
        if (hour < 10) {
          hourPad = '0' + hour;
        }
        for (let minute = 0; minute <= 59; minute += 30) {
          let minutePad = '' + minute;
          if (minute < 10) {
            minutePad = '0' + minute;
          }
          if (hour < 24 || minute == 0) { // however we do not want to show 24:30
            this.timeOptions.push({
              label: hourPad + ':' + minutePad,
              value: hourPad + minutePad,
            });
          }
        }
      }
    },
    methods: {
      moment,
      onSubmit(e) {
        e.preventDefault();
        this.contactForm.validateFields((err, values) => {
          if (Number(this.contactForm.getFieldValue('notif_from')) > Number(this.contactForm.getFieldValue('notif_to')) || Number(this.contactForm.getFieldValue('notif_from_sms')) > Number(this.contactForm.getFieldValue('notif_to_sms'))) {
            this.$showErrorMessage('Invalid value for notification period');
            return;
          }

          if (!err) {
            const bodyParams = this._.cloneDeep(values);
            this.$emit('submit', bodyParams);
          }
        });
      },
      onCancel() {
        this.$router.push('/contact/list');
      },
      setContactForm() {
        this.contactForm.setFieldsValue({
          notif_from: this.contact.notif_from,
          notif_to: this.contact.notif_to,
          batch_email: Boolean(this.contact.batch_email),
          enable_email_baseline: Boolean(this.contact.enable_email_baseline),
          contact_group_id: this.contact.contact_group_id,
          name: this.contact.name,
          email: this.contact.email,
          description: this.contact.description,
          notif_day: this.contact.notif_day,
          email_subject_prefix: this.contact.email_subject_prefix
        });

        if (this.isShowSMSConfig) {
          this.contactForm.setFieldsValue({
            notif_from_sms: this.contact.notif_from_sms,
            notif_to_sms: this.contact.notif_to_sms,
            notif_day_sms: this.contact.notif_day_sms,
            sms: this.contact.sms
          });
        }
      },
      async getContactGroupList() {
        try {
          this.contactGroups = await ContactGroupService.getList();
          this.setContactForm();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .a-body {
    padding: 20px;
  }

  .email-config {
    background-color: #f7f7f7;
    padding: 20px;
  }

  .email-config__title {
    color: #323232;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }
</style>
